<template>
  <nav id="sidebar" class="navbar-light navbar-collapse w-auto bg-light shadow">
    <ul class="navbar-nav text-secondary my-3">
      <li
        v-for="item in menuItems"
        :key="item.to"
        class="nav-item my-1"
        :class="{ active: isMenuActive(item) }"
      >
        <router-link
          :to="item.to"
          class="nav-link rounded nav-links"
          :class="{ 'active-menu': isMenuActive(item) }"
          @click="toggleSubMenu(item)"
        >
          <template v-if="item.icon">
            <font-awesome-icon
              :icon="item.icon"
              class="ms-3 mx-3 text-danger"
              :class="{ 'text-danger': isMenuActive(item) }"
            />
          </template>
          <template v-else>
            <img
              :src="item.icons"
              class="ms-3 mx-3 icons"
              :class="{ 'text-danger': isMenuActive(item) }"
              alt="icon"
            />
          </template>
          {{ item.label }}
        </router-link>
        <ul
          v-if="item.submenu && item.expanded"
          class="submenu nav-item text-secondary ms-4"
        >
          <li
            v-for="subitem in item.submenu"
            :key="subitem.to"
            class="nav-item text-secondary rounded"
            :class="{ 'text-danger': isMenuActive(subitem) }"
          >
            <router-link
              :to="subitem.to"
              class="nav-link nav-links"
              :class="{ 'text-danger': isMenuActive(subitem) }"
            >
              <small>{{ subitem.label }}</small>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<style>
#sidebar {
  height: 100%;
  transition: all 0.3s ease;
  overflow: auto;
  padding: 0 10px 20px;
  font-family: "Inter-Medium", sans-serif;
  font-size: 14px;
  line-height: 3rem;
  background: rgba(255, 128, 128, 0.2);
  border-right: 2px solid rgba(255, 128, 128, 0.2);
}

.nav-item .active-submenu {
  border-left: 2px solid rgba(181, 26, 26, 1);
}

.nav-item .active-submenu:hover {
  background: rgba(181, 26, 26, 1);
  border-radius: 0;
}

.nav-item .active-menu {
  border-left: 10px solid rgba(181, 26, 26, 1);
  border-radius: 10px 0 0 10px;
  color: rgba(181, 26, 26, 1);
}

.nav-item .active-menu:hover {
  border-radius: 10px 0 0 10px;
}

.nav-link:hover {
  /* background: rgba(181, 26, 26, 1); */
  /* color: #fff; */
  color: rgba(181, 26, 26, 1);
}

.icons {
  height: 24px;
  width: 24px;
}
</style>

<script>
import GlobalDataMixin from "../GlobalDataMixin";

export default {
  mixins: [GlobalDataMixin],
  components: {},
  name: "SidebarComponent",
  data() {
    return {
      menuItems: [],
    };
  },
  created() {
    if (this.userData.role.includes("ADMIN")) {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Master Data",
          to: "",
          icons: require("../assets/icons/master.png"),
          submenu: [
            {
              label: "User Kontraktor",
              to: "/manajement/kontraktor/users",
            },
            {
              label: "User Internal",
              to: "/manajement/internal/users",
            },
            {
              label: "Kontraktor",
              to: "/manajement/kontraktor",
            },
            {
              label: "Kontrak",
              to: "/kontrak",
            },
          ],
          expanded: false,
        },
        {
          label: "Approval CoC",
          to: "",
          icons: require("../assets/icons/coolicon.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/approval-sio",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio",
            },
            {
              label: "Update Data",
              to: "/update-data-sio",
            },
          ],
          expanded: false,
        },
        {
          label: "Approval IMKP",
          to: "/approval-imkp",
          icons: require("../assets/icons/window_check.png"),
        },
      ];
    }
    else if (this.userData.role === "kontraktor") {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Profile Perusahaan",
          to: "/profile",
          icons: require("../assets/icons/buildings.png"),
        },
        {
          label: "Kontrak",
          to: "/kontrak",
          icons: require("../assets/icons/file.png"),
        },
        {
          label: "CoC",
          to: "/sio",
          icons: require("../assets/icons/notes.png"),
        },
        {
          label: "Penilaian PJO",
          to: "",
          icons: require("../assets/icons/folder.png"),
          submenu: [
            {
              label: "NC Presentasi PJO",
              to: "/penilaian-pjo/nc-presentasi",
            },
          ],
        },
        {
          label: "IMKP",
          to: "/imkp",
          icons: require("../assets/icons/notes.png"),
        },
        // {
        //   label: "Environment",
        //   to: "/enviroment",
        //   icons: require("../assets/icons/file-contract.png"),
        // },
      ];
    }
    else if (this.userData.role.includes("OHS")) {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Approval CoC",
          to: "",
          icons: require("../assets/icons/coolicon.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/approval-sio",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio",
            },
          ],
          expanded: false,
        },
        {
          label: "Report CoC",
          to: "",
          icons: require("../assets/icons/folder.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/pengajuan-baru-report",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio-report",
            },
            {
              label: "Update Data",
              to: "/update-data-report",
            },
          ],
          expanded: false,
        },
        {
          label: "Approval IMKP",
          to: "/approval-imkp",
          icons: require("../assets/icons/window_check.png"),
        },
      ];
    }
    else if (this.userData.role.includes("reporter")) {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Approval CoC",
          to: "",
          icons: require("../assets/icons/coolicon.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/approval-sio",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio",
            },
          ],
          expanded: false,
        },
        {
          label: "Report CoC",
          to: "",
          icons: require("../assets/icons/folder.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/pengajuan-baru-report",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio-report",
            },
            {
              label: "Update Data",
              to: "/update-data-report",
            },
          ],
          expanded: false,
        },
        {
          label: "Report IMKP",
          to: "/approval-imkp",
          icons: require("../assets/icons/file.png"),
        },
      ];
    }
    else if (this.userData.role.includes("ENVIRONMENT")) {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Approval CoC",
          to: "",
          icons: require("../assets/icons/coolicon.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/approval-sio",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio",
            },
          ],
          expanded: false,
        },
        {
          label: "Environment",
          to: "/enviroment",
          icons: require("../assets/icons/file-contract.png"),
        },
      ];
    }
    else {
      this.menuItems = [
        {
          label: "Dashboard",
          to: "/dashboard",
          icons: require("../assets/icons/dashboard.png"),
        },
        {
          label: "Approval CoC",
          to: "",
          icons: require("../assets/icons/coolicon.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/approval-sio",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio",
            },
          ],
          expanded: false,
        },
        {
          label: "Report CoC",
          to: "",
          icons: require("../assets/icons/folder.png"),
          submenu: [
            {
              label: "Pengajuan Baru",
              to: "/pengajuan-baru-report",
            },
            {
              label: "Pergantian PJO",
              to: "/pergantian-sio-report",
            },
            {
              label: "Update Data",
              to: "/update-data-report",
            },
          ],
          expanded: false,
        },
      ];
    }
    for (const item of this.menuItems) {
      if (item.submenu) {
        const isSubmenuActive = item.submenu.some(
          (subitem) => this.$route.path === subitem.to
        );
        if (isSubmenuActive) {
          item.expanded = true;
        }
      }
    }
  },
  methods: {
    isMenuActive(menuItem) {
      let rp = this.$route.path;
      if (rp === menuItem.to) {
        return true;
      }

      if (menuItem.submenu) {
        return menuItem.submenu.some((subitem) => rp === subitem.to);
      }
      return false;
    },
    toggleSubMenu(menuItem) {
      if (menuItem.submenu) {
        menuItem.expanded = !menuItem.expanded;
        this.menuItems
          .filter((item) => item !== menuItem && item.submenu)
          .forEach((item) => (item.expanded = false));
      }
    },
  },
  mounted() {},
};
</script>
